import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './inquiry.css';
import API_BASE_URL from '../../config/api';
import SupportMenu from './SupportMenu';

const Inquiry = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        equipment: '',
        eventDate: '',
        location: '',
        eventType: '',
        scale: '',
        content: '',
        privacy: false
    });

    const handleChange = (e) => {
        const {
            name,
            value,
            type,
            checked
        } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                type === 'checkbox'
                    ? checked
                    : value
        }));
    };

    const handleEquipment = (equipment) => {
        setFormData((prev) => ({
            ...prev,
            equipment
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name.trim()) {
            alert('이름을 입력해주세요.');
            return;
        }

        if (!formData.phone.trim()) {
            alert('연락처를 입력해주세요.');
            return;
        }

        if (!formData.equipment) {
            alert('필요한 장비를 선택해주세요.');
            return;
        }

        if (!formData.eventDate) {
            alert('행사 예정일을 선택해주세요.');
            return;
        }

        if (!formData.content.trim()) {
            alert('문의 내용을 입력해주세요.');
            return;
        }

        if (!formData.privacy) {
            alert('개인정보 수집 및 이용에 동의해주세요.');
            return;
        }

        try {
            const response = await fetch(
                `${API_BASE_URL}/api/inquiries`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        name: formData.name,
                        phone: formData.phone,
                        email: formData.email,
                        equipment: formData.equipment,
                        eventDate: formData.eventDate,
                        location: formData.location,
                        eventType: formData.eventType,
                        scale: formData.scale,
                        content: formData.content
                    })
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data.message || '견적문의 접수에 실패했습니다.'
                );
            }

            alert(
                '견적문의가 접수되었습니다.\n확인 후 연락드리겠습니다.'
            );

            setFormData({
                name: '',
                phone: '',
                email: '',
                equipment: '',
                eventDate: '',
                location: '',
                eventType: '',
                scale: '',
                content: '',
                privacy: false
            });
        } catch (error) {
            console.error('견적문의 접수 오류:', error);

            alert(
                error.message ||
                '견적문의 접수 중 오류가 발생했습니다.'
            );
        }
    };

    return (
        <div className="inquiry-page">
            {/* =============================================
                SUB VISUAL
            ============================================= */}
            <section className="inquiry-sub-visual">
                <div className="inquiry-sub-overlay"></div>
                <div className="inquiry-sub-inner">
                    <p>INQUIRY</p>
                    <h1>견적문의</h1>
                    {/* <span>
                        행사 정보를 남겨주시면
                        <br />
                        현장에 적합한 장비와 구성을 안내해드립니다.
                    </span> */}
                    <div className="inquiry-breadcrumb">
                        <Link to="/">HOME</Link>
                        <span>›</span>
                        <strong>견적문의</strong>
                    </div>
                </div>
            </section>

            <SupportMenu />

            {/* =============================================
                INTRO
            ============================================= */}
            <section className="inquiry-intro">
                <div className="inquiry-container">
                    <div className="inquiry-section-title">
                        <p>REQUEST A QUOTE</p>
                        <h2>견적문의</h2>
                        <span>
                            행사 장소와 일정, 필요한 장비를 알려주시면
                            <br />
                            확인 후 적합한 구성으로 안내해드립니다.
                        </span>
                    </div>
                </div>
            </section>

            {/* =============================================
                FORM SECTION
            ============================================= */}
            <section className="inquiry-form-section">
                <div className="inquiry-container inquiry-layout">
                    {/* =====================================
                        LEFT - FORM
                    ===================================== */}
                    <form
                        className="inquiry-form"
                        onSubmit={handleSubmit}
                    >
                        {/* CUSTOMER INFO */}
                        <div className="inquiry-form-block">
                            <div className="inquiry-form-heading">
                                <span>01</span>
                                <div>
                                    <h3>고객 정보</h3>
                                    <p>상담을 위해 기본 정보를 입력해주세요.</p>
                                </div>
                            </div>

                            <div className="inquiry-form-grid">
                                <div className="inquiry-field">
                                    <label htmlFor="name">
                                        이름
                                        <em>*</em>
                                    </label>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="이름을 입력해주세요."
                                    />
                                </div>

                                <div className="inquiry-field">
                                    <label htmlFor="phone">
                                        연락처
                                        <em>*</em>
                                    </label>
                                    <input
                                        id="phone"
                                        name="phone"
                                        type="tel"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        placeholder="010-0000-0000"
                                    />
                                </div>

                                <div className="inquiry-field inquiry-field-full">
                                    <label htmlFor="email">
                                        이메일
                                    </label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="example@naver.com"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* EVENT INFO */}
                        <div className="inquiry-form-block">
                            <div className="inquiry-form-heading">

                                <span>
                                    02
                                </span>

                                <div>
                                    <h3>
                                        행사 정보
                                    </h3>

                                    <p>
                                        현장에 적합한 장비 구성을 위해
                                        행사 정보를 알려주세요.
                                    </p>
                                </div>

                            </div>


                            {/* EQUIPMENT */}

                            <div className="inquiry-field inquiry-equipment-field">

                                <label>
                                    필요한 장비
                                    <em>*</em>
                                </label>

                                <div className="inquiry-equipment">

                                    <button
                                        type="button"
                                        className={
                                            formData.equipment === 'LED 전광판'
                                                ? 'active'
                                                : ''
                                        }
                                        onClick={() =>
                                            handleEquipment('LED 전광판')
                                        }
                                    >
                                        <i className="mdi mdi-monitor"></i>

                                        <strong>
                                            LED 전광판
                                        </strong>

                                        <span>
                                            LED DISPLAY
                                        </span>
                                    </button>


                                    <button
                                        type="button"
                                        className={
                                            formData.equipment === '빔프로젝터'
                                                ? 'active'
                                                : ''
                                        }
                                        onClick={() =>
                                            handleEquipment('빔프로젝터')
                                        }
                                    >
                                        <i className="mdi mdi-projector"></i>

                                        <strong>
                                            빔프로젝터
                                        </strong>

                                        <span>
                                            PROJECTOR
                                        </span>
                                    </button>


                                    <button
                                        type="button"
                                        className={
                                            formData.equipment === '상담 필요'
                                                ? 'active'
                                                : ''
                                        }
                                        onClick={() =>
                                            handleEquipment('상담 필요')
                                        }
                                    >
                                        <i className="mdi mdi-help-circle-outline"></i>

                                        <strong>
                                            상담이 필요해요
                                        </strong>

                                        <span>
                                            CONSULTING
                                        </span>
                                    </button>

                                </div>

                            </div>


                            <div className="inquiry-form-grid">

                                <div className="inquiry-field">

                                    <label htmlFor="eventDate">
                                        행사 예정일
                                        <em>*</em>
                                    </label>

                                    <input
                                        id="eventDate"
                                        name="eventDate"
                                        type="date"
                                        value={formData.eventDate}
                                        onChange={handleChange}
                                    />

                                </div>


                                <div className="inquiry-field">

                                    <label htmlFor="location">
                                        행사 장소
                                    </label>

                                    <input
                                        id="location"
                                        name="location"
                                        type="text"
                                        value={formData.location}
                                        onChange={handleChange}
                                        placeholder="예: 서울 ○○호텔"
                                    />

                                </div>


                                <div className="inquiry-field">

                                    <label htmlFor="eventType">
                                        행사 유형
                                    </label>

                                    <select
                                        id="eventType"
                                        name="eventType"
                                        value={formData.eventType}
                                        onChange={handleChange}
                                    >
                                        <option value="">
                                            행사 유형을 선택해주세요.
                                        </option>

                                        <option value="기업행사">
                                            기업행사
                                        </option>

                                        <option value="세미나 · 컨퍼런스">
                                            세미나 · 컨퍼런스
                                        </option>

                                        <option value="전시 · 박람회">
                                            전시 · 박람회
                                        </option>

                                        <option value="공연 · 축제">
                                            공연 · 축제
                                        </option>

                                        <option value="종교행사">
                                            종교행사
                                        </option>

                                        <option value="촬영 · 광고">
                                            촬영 · 광고
                                        </option>

                                        <option value="기타">
                                            기타
                                        </option>
                                    </select>
                                </div>

                                <div className="inquiry-field">
                                    <label htmlFor="scale">
                                        행사 규모
                                    </label>
                                    <input
                                        id="scale"
                                        name="scale"
                                        type="text"
                                        value={formData.scale}
                                        onChange={handleChange}
                                        placeholder="예: 약 300명"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* DETAIL */}
                        <div className="inquiry-form-block">
                            <div className="inquiry-form-heading">
                                <span>03</span>
                                <div>
                                    <h3>문의 내용</h3>
                                    <p>
                                        필요한 장비나 설치 환경에 대해
                                        자유롭게 작성해주세요.
                                    </p>
                                </div>
                            </div>

                            <div className="inquiry-field">
                                <label htmlFor="content">
                                    문의 내용
                                    <em>*</em>
                                </label>
                                <textarea
                                    id="content"
                                    name="content"
                                    value={formData.content}
                                    onChange={handleChange}
                                    placeholder={
                                        '예) 기업행사에서 사용할 LED 전광판을 알아보고 있습니다.\n행사 장소는 서울이며 약 300명 규모입니다.\n적합한 화면 크기와 견적을 안내받고 싶습니다.'
                                    }
                                />
                            </div>
                        </div>

                        {/* PRIVACY */}
                        <div className="inquiry-privacy">
                            <div className="inquiry-privacy-text">
                                <strong>
                                    개인정보 수집 및 이용 안내
                                </strong>
                                <p>
                                    견적 상담을 위해 이름, 연락처,
                                    이메일 등의 개인정보를 수집합니다.
                                    수집된 정보는 상담 및 견적 안내
                                    목적으로만 이용됩니다.
                                </p>
                            </div>

                            <label className="inquiry-checkbox">
                                <input
                                    type="checkbox"
                                    name="privacy"
                                    checked={formData.privacy}
                                    onChange={handleChange}
                                />
                                <span>
                                    개인정보 수집 및 이용에 동의합니다.
                                    <em> *</em>
                                </span>

                            </label>
                        </div>

                        {/* SUBMIT */}
                        <button
                            type="submit"
                            className="inquiry-submit"
                        >
                            견적 문의하기

                            <i className="mdi mdi-arrow-right"></i>
                        </button>
                    </form>

                    {/* =====================================
                        RIGHT - INFO
                    ===================================== */}
                    <aside className="inquiry-side">
                        <div className="inquiry-contact-card">
                            <div className="inquiry-side-title">
                                <strong>
                                    빠른 상담 안내
                                </strong>

                                <span>
                                    제품 문의, 견적 상담 등 언제든지 문의해주세요.
                                </span>
                            </div>

                            <div className="inquiry-phone">
                                <div className="inquiry-phone-icon">
                                    <i className="mdi mdi-phone"></i>
                                </div>

                                <div>
                                    <span>
                                        고객센터
                                    </span>

                                    <a href="tel:01090453707">
                                        010-9045-3707
                                    </a>

                                    <p>
                                        평일 09:00 ~ 18:00
                                        <br />
                                        주말 · 공휴일 휴무
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="inquiry-side-card">
                            <p>
                                GUIDE
                            </p>
                            <h4>
                                이렇게 알려주시면
                                더 빠르게 상담할 수 있어요.
                            </h4>
                            <ul className="inquiry-guide-list">
                                <li>
                                    <span>01</span>
                                    <p>
                                        <strong>
                                            행사 일정
                                        </strong>

                                        설치 및 철거 일정을 포함해
                                        알려주세요.
                                    </p>
                                </li>
                                <li>
                                    <span>02</span>
                                    <p>
                                        <strong>
                                            행사 장소
                                        </strong>

                                        실내 · 실외 여부와 장소를
                                        알려주세요.
                                    </p>
                                </li>
                                <li>
                                    <span>03</span>
                                    <p>
                                        <strong>
                                            행사 규모
                                        </strong>

                                        예상 인원과 공간 규모를
                                        알려주세요.
                                    </p>
                                </li>
                                <li>
                                    <span>04</span>
                                    <p>
                                        <strong>
                                            필요한 장비
                                        </strong>

                                        정확히 모르셔도 상담을 통해
                                        안내해드립니다.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </aside>
                </div>
            </section>


            {/* =============================================
                BOTTOM CONTACT
            ============================================= */}

            <section className="inquiry-bottom">

                <div className="inquiry-bottom-inner">

                    <div>
                        <p>
                            MTMEDIA CONSULTING
                        </p>

                        <h2>
                            어떤 장비가 필요한지
                            <br />
                            정확히 모르셔도 괜찮습니다.
                        </h2>

                        <span>
                            행사 목적과 공간, 규모를 알려주시면
                            현장에 적합한 영상 장비를 안내해드립니다.
                        </span>
                    </div>

                    <a href="tel:01090453707">

                        <i className="mdi mdi-phone"></i>

                        <div>
                            <span>
                                전화 상담
                            </span>

                            <strong>
                                010-9045-3707
                            </strong>
                        </div>

                    </a>

                </div>

            </section>

        </div>
    );
};

export default Inquiry;